// src/components/jobPost/steps/Step5Schedule.jsx
import { useState } from "react";
import { Card, CardContent } from "../../../ui/card";
import { Calendar } from "../../../ui/calendar"; 
import { useJobPostProgressContext } from "../../../../context/jobPostProgressFrom";
import { StepFooterNav } from "../../shared/NavigationFooter";
import { FaClock, FaCalendarCheck } from "react-icons/fa";

export function Step5({ currentStep, totalSteps, nextStep, preStep }) {
  const { jobPostProgress, setScheduledDate } = useJobPostProgressContext();

  const today = new Date();
  const initialDate = jobPostProgress.scheduledDate
    ? new Date(jobPostProgress.scheduledDate)
    : today;

  const [selected, setSelected] = useState(initialDate);
  const [month, setMonth] = useState(initialDate); // controls which month calendar opens to

  const handleDateSelect = (date) => {
    if (date) {
      setSelected(date);
      setScheduledDate(date);
      setMonth(date); // jump to selected date’s month
    }
  };

  const handleNext = () => {
    if (!selected) return;
    setScheduledDate(selected);
    nextStep();
  };

  return (
    <div className="space-y-12 py-5 md:py-10">
      {/* Title */}
      <div className="text-center space-y-4">
  <h1 className="text-3xl md:text-5xl font-bold text-black">Schedule</h1>
  <p className="text-xl text-gray-600 max-w-2xl mx-auto">
    When do you need this service completed?
  </p>
  
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mt-8">
    {/* Same Day Card */}
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 hover:shadow-xl transition-all duration-300">
      <div className="flex items-center gap-4">
        <div className="w-16 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
          <FaClock className="w-6 h-6 text-blue-600" />
        </div>
        <div className="text-left">
          <h3 className="text-xl font-bold text-gray-900">Same-day</h3>
          <p className="text-gray-600 mt-1">
            Pre-authorization only. Payment when service complete.
          </p>
        </div>
      </div>
    </div>

    {/* Future Dates Card */}
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 hover:shadow-xl transition-all duration-300">
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
          <FaCalendarCheck className="w-6 h-6 text-green-600" />
        </div>
        <div className="text-left">
          <h3 className="text-xl font-bold text-gray-900">Future dates</h3>
          <p className="text-gray-600 mt-1">
            Payment required to schedule posting.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

      {/* Calendar */}
      <div className="max-w-sm mx-auto">
        <Card>
          <CardContent>
            <Calendar
              mode="single"
              selected={selected}
              onSelect={handleDateSelect}
              month={month}            // 👈 ensures correct month is shown
              onMonthChange={setMonth} // 👈 keep month in sync when navigating
              disabled={(date) =>
                date < new Date(new Date().setHours(0, 0, 0, 0))
              }
              initialFocus
              className="w-full"
            />
          </CardContent>
        </Card>
      </div>

      {/* Footer Navigation */}
      <StepFooterNav
        currentStep={currentStep}
        totalSteps={totalSteps}
        onBack={preStep}
        onNext={handleNext}
      />
    </div>
  );
}
